// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JhjC","option":"styles_option__jwRNe","active":"styles_active__1meao"};